// pp-credito.js — Panel de Línea de Crédito B2B en el área de cliente.
//
// Lee UNA sola vez el estado de crédito de la empresa desde el App Proxy
// /apps/crm/customer-credito (vía la capa PPAccount de prefetch+dedup si existe)
// y llena TODAS las instancias del panel [data-pp-credito] que haya en la página
// (variantes full / facturacion / compact — el hero del dashboard, el resumen de
// facturación y el bloque compacto de "Mi Empresa" comparten esta lectura).
//
// Skeleton gemelo: cada panel nace con un skeleton [data-pp-credito-skeleton]
// visible que reserva su espacio desde el primer paint (para NO empujar el
// contenido de abajo). El JS lo oculta al resolver y revela el panel real.
//
// Degrada con gracia: si el fetch falla, o la cuenta no tiene línea de crédito
// (has_credit:false / found:false), el skeleton se oculta y el panel NO aparece
// — sin errores en consola. El panel es SOLO para empresas con crédito.
//
// Contrato del backend (GET /apps/crm/customer-credito):
//   { found, state, has_credit, estatus, dias, limit, used, available,
//     orders_count, orders:[{ number, outstanding, due_date, delivered }],
//     spend_12m, threshold, paid_orders_12m, min_paid_orders, eligible,
//     request }
// state ∈ construyendo | elegible | en_revision | con_credito | suspendido.
//   - con_credito / suspendido → panel de crédito (arriba).
//   - construyendo / elegible / en_revision → bloque de elegibilidad
//     [data-pp-eleg]: progreso hacia gasto 12m + compras de contado, y el
//     botón "Solicitar crédito" (POST /apps/crm/customer-credito-solicitar).
// Los montos (limit/used/available/outstanding/spend_12m/threshold) vienen en
// PESOS MXN (unidades enteras del CRM, no centavos).

(function () {
  'use strict';

  var PATH = 'customer-credito';
  var ENDPOINT = '/apps/crm/' + PATH;

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-pp-credito]'));
  var skels = Array.prototype.slice.call(document.querySelectorAll('[data-pp-credito-skeleton]'));
  if (!roots.length && !skels.length) return;

  function hideSkeletons() { skels.forEach(function (s) { s.hidden = true; }); }
  function hideAllPanels() { roots.forEach(function (r) { r.hidden = true; }); }

  // En el editor del theme no hay sesión de cliente → no consultar; deja el
  // espacio limpio (sin skeleton perpetuo ni panel).
  if (window.Shopify && window.Shopify.designMode) { hideSkeletons(); hideAllPanels(); return; }

  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  // "$1,234 MXN" — sin centavos, formato es-MX (pesos enteros).
  function money(n) {
    var v = Math.round(Number(n) || 0);
    return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' MXN';
  }
  // Igual pero sin sufijo " MXN" (para el número grande y el "de $X").
  function moneyBare(n) {
    var v = Math.round(Number(n) || 0);
    return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function parseDate(s) {
    if (!s) return null;
    var p = String(s).split('-');
    if (p.length !== 3) return null;
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    return isNaN(d.getTime()) ? null : d;
  }
  function todayMid() {
    var n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  }
  function fmtDate(d) {
    var label = d.getDate() + ' ' + MESES[d.getMonth()];
    if (d.getFullYear() !== new Date().getFullYear()) label += ' ' + d.getFullYear();
    return label;
  }
  // Fecha "hito" de la línea (comenzó / vence): siempre con año.
  function fmtLong(d) {
    return d.getDate() + ' ' + MESES[d.getMonth()] + ' ' + d.getFullYear();
  }

  function q(root, sel) { return root.querySelector(sel); }
  function setText(root, sel, txt) {
    var el = root.querySelector(sel);
    if (el) el.textContent = txt;
  }

  // Tiempo relativo hasta el vencimiento (o desde, si ya venció).
  function relTime(dd, today) {
    var days = Math.round((dd - today) / 86400000);
    if (days > 1) return 'en ' + days + ' días';
    if (days === 1) return 'mañana';
    if (days === 0) return 'hoy';
    var a = Math.abs(days);
    return 'hace ' + a + (a === 1 ? ' día' : ' días');
  }

  // Construye una fila de orden a crédito (li): número (enlace a la orden),
  // vencimiento + tiempo relativo, y monto.
  function buildOrderRow(o) {
    var li = document.createElement('li');
    li.className = 'pp-credito__order';

    // Número — enlace a la LISTA de órdenes (para verla/pagarla). NO deep-link:
    // el store usa un token hash por orden en la URL (order.customer_url), no el
    // id numérico, y las órdenes del panel son de toda la empresa (un miembro
    // solo puede abrir las suyas). La lista es el destino correcto y sin 404.
    // Nuestra lista, no /account/orders: bajo cuentas nuevas /account/* cae en
    // la cuenta hospedada de Shopify y saca al cliente del portal.
    var num = document.createElement('a');
    num.href = '/pages/cliente-ordenes';
    num.className = 'pp-credito__order-num';
    num.textContent = o.number || 'Orden';
    li.appendChild(num);

    var amt = document.createElement('span');
    amt.className = 'pp-credito__order-amt';
    amt.textContent = money(o.outstanding);
    li.appendChild(amt);

    var due = document.createElement('span');
    due.className = 'pp-credito__order-due';
    var dd = parseDate(o.due_date);
    var today = todayMid();
    if (!dd) {
      due.classList.add('pp-credito__order-due--pending');
      due.textContent = 'Pendiente de entrega';
    } else if (dd < today) {
      li.classList.add('pp-credito__order--overdue');
      due.classList.add('pp-credito__order-due--overdue');
      due.textContent = 'Vencida ' + fmtDate(dd) + ' · ' + relTime(dd, today);
    } else {
      due.textContent = 'Vence ' + fmtDate(dd) + ' · ' + relTime(dd, today);
    }
    li.appendChild(due);
    return li;
  }

  function fill(root, d) {
    var limit = Number(d.limit) || 0;
    var used = Number(d.used) || 0;
    var avail = (d.available != null) ? Number(d.available) : (limit - used);
    var pct = limit > 0 ? Math.max(0, Math.min(100, (used / limit) * 100)) : 0;
    var pctR = Math.round(pct);

    var suspended = d.estatus === 'Suspendido';
    var enProceso = d.estatus === 'En proceso';

    // Montos
    setText(root, '[data-pp-credito-available]', moneyBare(avail));
    setText(root, '[data-pp-credito-limit]', moneyBare(limit));
    setText(root, '[data-pp-credito-used]', money(used));
    setText(root, '[data-pp-credito-pct]', pctR + '%');

    // Barra de progreso (used/limit)
    var fillEl = q(root, '[data-pp-credito-bar-fill]');
    if (fillEl) {
      fillEl.style.setProperty('--pp-credito-fill', pct + '%');
      var level = (suspended || enProceso) ? 'muted' : (pct >= 90 ? 'crit' : (pct >= 80 ? 'warn' : 'ok'));
      fillEl.setAttribute('data-level', level);
    }
    var bar = q(root, '[data-pp-credito-bar]');
    if (bar) {
      bar.setAttribute('aria-valuenow', String(pctR));
      bar.setAttribute('aria-valuetext', pctR + '% de tu línea de crédito usado');
    }

    // Chips
    var oc = Number(d.orders_count) || 0;
    setText(root, '[data-pp-credito-orders-count]', oc + (oc === 1 ? ' orden a crédito' : ' órdenes a crédito'));
    var diasEl = q(root, '[data-pp-credito-dias]');
    if (diasEl) {
      if (d.dias != null) {
        diasEl.hidden = false;
        var diasVal = q(diasEl, '[data-pp-credito-dias-val]');
        if (diasVal) diasVal.textContent = d.dias + (d.dias === 1 ? ' día' : ' días');
        else diasEl.textContent = 'Plazo: ' + d.dias + (d.dias === 1 ? ' día' : ' días');
      } else {
        diasEl.hidden = true;
      }
    }

    // Modal "Sobre mi crédito" (variante full): facts del detalle. Guardados
    // con setText → no-op si el elemento no existe en esta variante.
    setText(root, '[data-pp-credito-orders-n]', String(oc));
    setText(
      root,
      '[data-pp-credito-plazo]',
      d.dias != null ? d.dias + (d.dias === 1 ? ' día' : ' días') : 'Sin plazo',
    );
    var dIni = parseDate(d.inicio);
    setText(root, '[data-pp-credito-inicio]', dIni ? fmtLong(dIni) : '—');
    var dVen = parseDate(d.vence);
    setText(root, '[data-pp-credito-vence]', dVen ? fmtLong(dVen) : 'Indefinido');

    // Badge de estatus
    var badge = q(root, '[data-pp-credito-status]');
    if (badge) {
      var map = {
        'Activo': ['ok', 'Activo'],
        'Suspendido': ['warn', 'Suspendida'],
        'En proceso': ['muted', 'En revisión']
      };
      var m = map[d.estatus] || ['muted', d.estatus || '—'];
      badge.setAttribute('data-status', m[0]);
      badge.textContent = m[1];
    }

    // Nota de estatus (suspendida / en revisión)
    var note = q(root, '[data-pp-credito-note]');
    if (note) {
      if (suspended) {
        note.hidden = false;
        note.setAttribute('data-tone', 'warn');
        note.textContent = 'Tu línea está suspendida — contacta a tu ejecutivo de cuenta.';
      } else if (enProceso) {
        note.hidden = false;
        note.setAttribute('data-tone', 'muted');
        note.textContent = 'Tu línea de crédito está en revisión.';
      } else {
        note.hidden = true;
      }
    }

    // Órdenes: normaliza + ordena (vencimiento asc; pendientes de entrega al final)
    var orders = Array.isArray(d.orders) ? d.orders.slice() : [];
    orders.sort(function (a, b) {
      var da = parseDate(a.due_date), db = parseDate(b.due_date);
      if (da && db) return da - db;
      if (da) return -1;
      if (db) return 1;
      return 0;
    });

    // Próximo pago (vencimiento más cercano con fecha)
    var nextEl = q(root, '[data-pp-credito-next]');
    if (nextEl) {
      var withDate = orders.filter(function (o) { return parseDate(o.due_date); });
      nextEl.removeAttribute('data-overdue');
      if (!orders.length) {
        nextEl.textContent = 'Sin pagos pendientes';
      } else if (!withDate.length) {
        nextEl.textContent = 'Al entregar tus pedidos';
      } else {
        var nd = parseDate(withDate[0].due_date);
        if (nd < todayMid()) {
          nextEl.setAttribute('data-overdue', '');
          nextEl.textContent = 'Vencido · ' + fmtDate(nd);
        } else {
          nextEl.textContent = fmtDate(nd);
        }
      }
    }

    // Lista de órdenes (full: hasta 3; facturacion: todas)
    var listEl = q(root, '[data-pp-credito-list]');
    if (listEl) {
      var maxAttr = listEl.getAttribute('data-max');
      var max = maxAttr ? parseInt(maxAttr, 10) : orders.length;
      listEl.textContent = '';
      var emptyEl = q(root, '[data-pp-credito-list-empty]');
      if (!orders.length) {
        if (emptyEl) emptyEl.hidden = false;
        listEl.hidden = true;
      } else {
        if (emptyEl) emptyEl.hidden = true;
        listEl.hidden = false;
        orders.slice(0, max).forEach(function (o) { listEl.appendChild(buildOrderRow(o)); });
      }
      // "y N más" cuando la lista corta oculta órdenes (variante full)
      var moreEl = q(root, '[data-pp-credito-list-more]');
      if (moreEl) {
        var hidden = orders.length - Math.min(orders.length, max);
        if (hidden > 0) {
          moreEl.hidden = false;
          moreEl.textContent = 'y ' + hidden + (hidden === 1 ? ' orden más' : ' órdenes más');
        } else {
          moreEl.hidden = true;
        }
      }
    }
  }

  // Modal "Sobre mi crédito" (solo variante full). Abre/cierra con botón,
  // backdrop, la X y Esc. Bloquea el scroll del fondo mientras está abierto.
  function wireModal(root) {
    var openBtn = q(root, '[data-pp-credito-open]');
    var modal = q(root, '[data-pp-credito-modal]');
    if (!openBtn || !modal || modal.getAttribute('data-wired')) return;
    modal.setAttribute('data-wired', '1');
    // Portar el modal al <body>: si un ancestro tiene transform/filter, atrapa
    // el position:fixed y el backdrop no cubre la pantalla (ni cierra al picar
    // afuera). Movido a body, el overlay es relativo al viewport. El contenido
    // ya quedó lleno por fill() antes de este wire.
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var card = q(modal, '.pp-credito__modal-card');
    var closers = modal.querySelectorAll('[data-pp-credito-close]');

    function open() {
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.documentElement.classList.add('pp-credito-modal-open');
      if (card) card.focus();
    }
    function close() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('pp-credito-modal-open');
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    Array.prototype.forEach.call(closers, function (c) {
      c.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !modal.hidden) close();
    });
  }

  // ── Elegibilidad ─────────────────────────────────────────────────────
  // Estados sin línea activa: construyendo / elegible / en_revision. El
  // bloque [data-pp-eleg] pinta el progreso hacia los dos requisitos
  // (gasto de 12 meses + compras de contado) y ofrece "Solicitar crédito".
  var SOLICITAR_ENDPOINT = '/apps/crm/customer-credito-solicitar';

  function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function clamp(min, max, v) { return Math.max(min, Math.min(max, v)); }

  // Texto introductorio por estado (mismo criterio de copy en español que el
  // resto del panel). Solo se aplica si el <p> nace vacío — así una instancia
  // que ya trae intro server-side (| t) conserva su copia.
  function elegIntro(state) {
    if (state === 'elegible') return 'Ya cumples los requisitos para tu línea de crédito. Solicítala y tu ejecutivo la activará.';
    if (state === 'en_revision') return 'Tu solicitud de crédito está en camino. Así va tu avance:';
    return 'Estás construyendo tu línea de crédito. Así vas hacia los requisitos:';
  }

  function fillEleg(el, d) {
    var state = d.state;

    var introEl = q(el, '[data-pp-eleg-intro]');
    if (introEl && !introEl.textContent.trim()) introEl.textContent = elegIntro(state);

    // Requisito: gasto de los últimos 12 meses
    var spend = Number(d.spend_12m) || 0;
    var thr = Number(d.threshold) || 0;
    setText(el, '[data-pp-eleg-gasto]', money(spend));
    setText(el, '[data-pp-eleg-umbral]', money(thr));
    var gPct = thr > 0 ? clamp(0, 100, (spend / thr) * 100) : (spend > 0 ? 100 : 0);
    var gBar = q(el, '[data-pp-eleg-bar-gasto]');
    if (gBar) gBar.style.width = gPct + '%';
    var gReq = q(el, '[data-pp-eleg-req="gasto"]');
    if (gReq) gReq.classList.toggle('is-done', thr > 0 && spend >= thr);

    // Requisito: compras de contado (opcional en la variante compacta de Inicio)
    var paid = Number(d.paid_orders_12m) || 0;
    var minP = Number(d.min_paid_orders) || 0;
    setText(el, '[data-pp-eleg-compras]', String(paid));
    setText(el, '[data-pp-eleg-min]', String(minP));
    var cPct = minP > 0 ? clamp(0, 100, (paid / minP) * 100) : (paid > 0 ? 100 : 0);
    var cBar = q(el, '[data-pp-eleg-bar-compras]');
    if (cBar) cBar.style.width = cPct + '%';
    var cReq = q(el, '[data-pp-eleg-req="compras"]');
    if (cReq) cReq.classList.toggle('is-done', minP > 0 && paid >= minP);

    // Solicitar (solo elegible) · aviso "en revisión" (solo en_revision)
    var solBtn = q(el, '[data-pp-eleg-solicitar]');
    if (solBtn) { solBtn.hidden = (state !== 'elegible'); wireSolicitar(solBtn, el); }
    var rev = q(el, '[data-pp-eleg-revision]');
    if (rev) rev.hidden = (state !== 'en_revision');

    el.hidden = false;
  }

  // POST de una solicitud de crédito (tipo: 'nueva' | 'aumento').
  // Resuelve a true solo si el backend confirma { ok: true }.
  function postSolicitud(tipo) {
    return fetch(SOLICITAR_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tipo: tipo })
    }).then(function (r) {
      if (!r.ok) return false;
      return r.json().then(function (j) { return !!(j && j.ok); }).catch(function () { return false; });
    }).catch(function () { return false; });
  }

  // Aviso de error discreto en el DOM (nunca window.alert — bloquea).
  function showElegError(refEl, msg) {
    var host = refEl.parentNode;
    if (!host) return;
    var el = host.querySelector('[data-pp-eleg-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pp-credito-eleg__error';
      el.setAttribute('data-pp-eleg-error', '');
      el.setAttribute('role', 'alert');
      host.insertBefore(el, refEl.nextSibling);
    }
    el.textContent = msg || 'No pudimos enviar tu solicitud. Inténtalo de nuevo.';
  }

  function wireSolicitar(btn, el) {
    if (btn.getAttribute('data-wired')) return;
    btn.setAttribute('data-wired', '1');
    btn.addEventListener('click', function () {
      btn.disabled = true;
      postSolicitud('nueva').then(function (ok) {
        if (ok) {
          btn.hidden = true;
          var rev = q(el, '[data-pp-eleg-revision]');
          if (rev) rev.hidden = false;
        } else {
          btn.disabled = false;
          showElegError(btn);
        }
      });
    });
  }

  // Botón "Solicitar aumento" (estado con_credito). Vive junto al panel.
  function wireAumentar(d) {
    qsa('[data-pp-eleg-aumentar]').forEach(function (btn) {
      if (d.state !== 'con_credito') { btn.hidden = true; return; }
      btn.hidden = false;
      if (btn.getAttribute('data-wired')) return;
      btn.setAttribute('data-wired', '1');
      btn.addEventListener('click', function () {
        btn.disabled = true;
        postSolicitud('aumento').then(function (ok) {
          if (ok) {
            var notice = document.createElement('p');
            notice.className = 'pp-credito-eleg__revision';
            notice.setAttribute('role', 'status');
            notice.hidden = false;
            notice.textContent = btn.getAttribute('data-t-ok') || 'Solicitud de aumento en revisión.';
            if (btn.parentNode) btn.parentNode.replaceChild(notice, btn);
          } else {
            btn.disabled = false;
            showElegError(btn, btn.getAttribute('data-t-error'));
          }
        });
      });
    });
  }

  function hideEleg() { qsa('[data-pp-eleg]').forEach(function (e) { e.hidden = true; }); }
  function hideAumentar() { qsa('[data-pp-eleg-aumentar]').forEach(function (b) { b.hidden = true; }); }

  // Lectura única compartida por todas las instancias.
  var read = (window.PPAccount && typeof window.PPAccount.get === 'function')
    ? window.PPAccount.get(PATH)
    : fetch(ENDPOINT, { method: 'GET', credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });

  read.then(function (d) {
    hideSkeletons();

    // Sin datos / cuenta sin registro de crédito → nada que mostrar.
    if (!d || d.found === false) { hideAllPanels(); hideEleg(); hideAumentar(); return; }

    var state = d.state;
    // con_credito / suspendido (o backend viejo sin `state` pero con línea) →
    // panel de crédito. El resto de estados con `state` → bloque de elegibilidad.
    var hasCredit = (state === 'con_credito' || state === 'suspendido') ||
                    (state == null && d.has_credit !== false);

    if (hasCredit) {
      roots.forEach(function (root) {
        try { fill(root, d); root.hidden = false; wireModal(root); }
        catch (e) { root.hidden = true; }
      });
      hideEleg();
      try { wireAumentar(d); } catch (e) { /* no-op */ }
      return;
    }

    if (state === 'construyendo' || state === 'elegible' || state === 'en_revision') {
      hideAllPanels();
      hideAumentar();
      qsa('[data-pp-eleg]').forEach(function (el) {
        try { fillEleg(el, d); } catch (e) { el.hidden = true; }
      });
      return;
    }

    // Sin línea y sin estado de elegibilidad → ocultar todo con gracia.
    hideAllPanels();
    hideEleg();
    hideAumentar();
  }).catch(function () {
    hideSkeletons();
    hideAllPanels();
    hideEleg();
    hideAumentar();
  });
})();
